// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__3+bfo","signupcard":"Profile_signupcard__hi78N","control":"Profile_control__0efi5","btn":"Profile_btn__Pph2a"};